<template>
  <div>
    <div class="row">
      <div class="col-md-4 form-group">
        <label>Choisir une filiere<font style="color: red">*</font></label>
        <select
          name="filiere"
          id="filiere"
          v-model="selected_filieres"
          class="form-control selectpicker"
          data-live-search="true"
          @change="filtrer_matieres($event)"
        >
          <option
            v-for="filiere in filieres"
            :key="`filiere_${filiere.id}`"
            :value="filiere.id"
          >
            {{ filiere.code + "-" + filiere.promotion }}
          </option>
        </select>
      </div>
      <div class="col-md-8 row align-items-center">
        <div class="col-md-10 form-group">
          <label for="matiere_id">
            Choisir une matière<font style="color: red">*</font>
          </label>
          <select
            name="matiere_id"
            v-model="matiere"
            id="matiere"
            class="form-control selectpicker"
            data-live-search="true"
            data-size="7"
            data-style="select-with-transition"
            title="Select Matière"
            @change="select_matiere($event)"
          >
            <option
              style="width: 97%"
              v-for="matiere in matieres_filtred"
              :key="`matiere_${matiere.id}`"
              :value="matiere.id"
            >
              {{
                matiere.service_id +
                "/" +
                matiere.serviceoff_id +
                " : " +
                matiere.nom
              }}
            </option>
          </select>
          <span style="color: #ffba00; display: none" id="enCoursSync">
            Synchronisation en cours Veuillez ne pas rafraîchir la page jusqu'à
            la fin de la synchronisation.
          </span>
          <span style="color: #0bb7af; display: none" id="syncTermine">
            Fin de la synchronisation.
          </span>
          <span style="color: red; display: none" id="syncError">
            Erreur de synchronisation Veuillez réessayer plus tard.
          </span>
        </div>
        <div class="col-md-2">
          <button
            id="synchronise"
            class="btn btn-success"
            @click.prevent="synchronise()"
          >
            <i aria-hidden="true" class="fas fa-sync"></i>Synchronise
          </button>
        </div>
      </div>
    </div>

    <div class="form-group">
      <label>Activité <font style="color: red">*</font></label>

      <div class="modal-table mb-4">
        <table class="table">
          <thead>
            <tr>
              <th scope="col">TYPE</th>
              <th scope="col">VOLUME</th>
              <th scope="col">TAUX</th>
              <th v-if="engager == 1" scope="col" class="text-right">
                <span class="prix-max btn btn-dark font-weight-bold btn-pill"
                  >{{ heurs_rest }}H MAX</span
                >
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-grey">
              <td>
                <select
                  v-model="type"
                  name="type"
                  style="margin-top: 0px"
                  class="form-control"
                >
                  <option
                    v-for="(type, index) in types"
                    :key="`type_${index}`"
                    style="width: 95%"
                    :value="type.titre"
                  >
                    {{ type.titre }}
                  </option>
                </select>
              </td>
              <td>
                <div class="input-group">
                  <input
                    type="text"
                    v-model="volume_horaire"
                    class="form-control"
                    placeholder="Volume Horaire"
                  />
                  <div class="input-group-append">
                    <span class="input-group-text">H</span>
                  </div>
                </div>
              </td>
              <td>
                <select
                  name="taux"
                  v-model="taux"
                  class="form-control selectpicker"
                  data-live-search="true"
                  data-style="select-with-transition"
                  title="Select Matière"
                >
                  <option
                    style="width: 97%"
                    v-for="taux in tauxes_filtres"
                    :key="`taux_${taux.id}`"
                    :value="vacataire.partenaire === 1 ? taux.taux_reel/10 : taux.taux_reel"
                  >
                    {{ vacataire.partenaire === 1 ? taux.taux_affiche/10 : taux.taux_affiche  }}
                    {{ vacataire.partenaire === 1 ? ' €' : ' DH'  }}
                  </option>
                </select>
              </td>
              <td>
                <button
                  type="button"
                  v-if="type != '' && volume_horaire != '' && taux != ''"
                  class="btn-plus btn btn-sm btn-icon btn-secondary btn-circle"
                >
                  <i
                    aria-hidden="true"
                    @click="ajouter"
                    class="fas fa-plus"
                  ></i>
                </button>
              </td>
            </tr>
            <input type="hidden" name="details" v-model="data" />
            <tr v-for="(detail, index) in details" :key="`detail_${index}`">
              <td>{{ detail.type }}</td>
              <td>{{ detail.volume_horaire }}</td>
              <td>{{ detail.taux }}</td>
              <td>
                <a
                  class="btn-minus btn btn-sm btn-icon btn-secondary btn-circle"
                  @click="supprimer(index)"
                  href="#"
                >
                  <i class="fas fa-minus"></i>
                </a>
              </td>
            </tr>
            <tr style="text-align: center" v-if="!details.length">
              <td colspan="4">Aucun détail trouvé…</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="form-group">
      <label>{{ vacataire.partenaire === 1 ? 'Objet de la mission' : 'Autre' }}</label>
      <textarea
        v-model="autre"
        class="form-control"
        name="autre"
        rows="3"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    matieres: Array,
    filieres: Array,
    tauxes: Array,
    types: Array,
    heurs_rest: 0,
    engager: Number,
    user: {},
    vacataire: {},
  },
  data() {
    return {
      matiere: null,
      selected_filieres: [],
      volume_horaire: "",
      taux: "",
      type: "",
      details: [],
      data: [],
      autre: null,
      filter_filiere: "",
      matieres_filtred: this.matieres,
    };
  },
  computed: {
    tauxes_filtres() {
      if (this.vacataire.partenaire === 1) {
        return this.tauxes;
      }
      return this.tauxes.filter((taux) => taux.only_partenaire != 1);
    },
  },
  methods: {
    synchronise() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };
      //disable btn synchronise when the request is loading
      var synchronise = document.getElementById("synchronise");
      synchronise.setAttribute("disabled");

      var enCoursSync = document.getElementById("enCoursSync");
      enCoursSync.style.display = "block";

      var syncTermine = document.getElementById("syncTermine");
      syncTermine.style.display = "none";

      var syncError = document.getElementById("syncError");
      //hide sync error msg
      syncError.style.display = "none";
      axios
        .get("/api/sync/matieres", config)
        .then((response) => {
          //enable btn after the sync end
          synchronise.removeAttribute("disabled");
          // hide sync en cour msg
          enCoursSync.style.display = "none";
          //show sync termine msg
          syncTermine.style.display = "block";

          this.matieres_filtred = response.data;
          setTimeout(function () {
            $("#matiere").selectpicker("refresh");
          }, 100);
        })
        .catch((error) => {
          // hide sync en cour msg
          enCoursSync.style.display = "none";
          //hide sync termine
          syncTermine.style.display = "none";

          //show sync termine msg
          syncError.style.display = "block";

          //enable btn
          synchronise.removeAttribute("disabled");
        });
    },
    ajouter() {
      this.details.push({
        volume_horaire: this.volume_horaire,
        taux: this.taux,
        type: this.type,
      });
      this.volume_horaire = this.taux = this.type = "";
      setTimeout(function () {
        $("#type").selectpicker("refresh");
      }, 200);
    },
    filtrer_matieres(event) {
      let config = {
        headers: {
          Authorization: "Bearer " + this.user.api_token,
        },
      };

      axios
        .get("/api/filter/matieres/" + event.target.value, config)
        .then((response) => {
          this.matieres_filtred = response.data;
          setTimeout(function () {
            $("#matiere").selectpicker("refresh");
          }, 100);
        })
        .catch((error) => {
          console.log(error);
        });
    },

    select_matiere(event) {
      const selectedMatiereId = event.target.value;
      const selectedMatiere = this.matieres.find(
        (matiere) => matiere.id === parseInt(selectedMatiereId)
      );

      if (selectedMatiere && selectedMatiere.filiere_id) {
        // Automatically set the associated filière
        this.selected_filieres = selectedMatiere.filiere_id;

        // Optional: Refresh the filière dropdown if needed
        setTimeout(() => {
          $("#filiere").selectpicker("refresh");
        }, 100);
      } else {
        console.error("No associated filière found for the selected matière.");
      }
    },

    supprimer(index) {
      this.details.pop(index);
    },
  },
  watch: {
    details: function (val) {
      this.data = JSON.stringify(this.details);
    },
  },
  mounted() {
    $(".kt_select2").select2().trigger("refresh");
  },
};
</script>


